'use strict';

module.exports = [
  {
    method: 'GET',
    path: '/permissions',
    handler: 'permissions.getPermissions',
  },
];
